import React from "react";

interface BrandIconProps {
  className?: string;
  width?: number;
  height?: number;
}

const BrandIcon: React.FC<BrandIconProps> = ({ className, width = 40, height = 40 }) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 40 40" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="40" height="40" rx="20" fill="#FFE8F9"/>
      <path 
        d="M19.9998 11.667C16.7748 11.667 14.1665 14.2753 14.1665 17.5003C14.1665 21.8753 19.9998 28.3337 19.9998 28.3337C19.9998 28.3337 25.8332 21.8753 25.8332 17.5003C25.8332 14.2753 23.2248 11.667 19.9998 11.667ZM15.8332 17.5003C15.8332 15.2003 17.6998 13.3337 19.9998 13.3337C22.2998 13.3337 24.1665 15.2003 24.1665 17.5003C24.1665 19.9003 21.7665 23.492 19.9998 25.7337C18.2665 23.5087 15.8332 19.8753 15.8332 17.5003Z" 
        fill="#4F4A4A"
      />
      <path 
        d="M19.9998 19.5837C21.1504 19.5837 22.0832 18.6509 22.0832 17.5003C22.0832 16.3497 21.1504 15.417 19.9998 15.417C18.8492 15.417 17.9165 16.3497 17.9165 17.5003C17.9165 18.6509 18.8492 19.5837 19.9998 19.5837Z" 
        fill="#4F4A4A"
      />
    </svg>
  );
};

export default BrandIcon;
